export default "__VITE_ASSET__Br3yJRUu__"